import type {UserDetailsMinRes} from './user.contract';
import {NewsType} from '../../../enums';
import {ProductDetailMinRes} from './product.contract';
import {Type} from 'class-transformer';
import {TranslationReq, TranslationRes} from './core';
import {L10nLocale} from 'angular-l10n';
import {FileUploadRes, MediaType} from '@yasc/yasc-material-components';


//ToDo Add separate english and german title and logs
export class NewsFeedRes {
    public id!: string;

    @Type(() => TranslationRes)
    public title!: TranslationRes;

    @Type(() => TranslationRes)
    public text!: TranslationRes;

    public productVersion?: string;
    public releaseDate: any;
    public type!: NewsType;

    @Type(() => FileUploadRes)
    public downloadLinks?: FileUploadRes[] = [];

    @Type(() => FileUploadRes)
    public imageLink!: FileUploadRes;

    @Type(() => ProductDetailMinRes)
    public product?: ProductDetailMinRes;

    public writtenBy!: UserDetailsMinRes;

    getIconLink(): string | null {
        return this.imageLink.link!;
    }

    getAttachments(locale: L10nLocale): FileUploadRes[] {
        if (this.downloadLinks == null) {
            return [];
        }
        return this.downloadLinks.filter(x =>
            x.type != MediaType.NewsFeedImage && (x.language == undefined || x.language == locale.language)
        );
    }
}

export class NewsFeedCreateUpdateReq {
    public title?: TranslationReq| TranslationRes;
    public text?: TranslationReq | TranslationRes;
    public productVersion?: string;
    public productId?: string;
    public releaseDate!: any;
    public type?: NewsType;
    public attachments: string[] | FileUploadRes[] = [];
    public imageId?: string;

    constructor(oldNews?: NewsFeedRes) {
        this.title = new TranslationReq();
        this.text = new TranslationReq();
        if (oldNews === undefined)
            return
        // @ts-ignore
        this.title = oldNews.title;
        // @ts-ignore
        this.text = oldNews.text;
        this.productVersion = oldNews.productVersion!;
        this.releaseDate = oldNews.releaseDate
        this.type = oldNews.type
        this.productId = oldNews.product!.id
    }

    public createEmpty(supportedCultures: string[]) {
        (this.title! as TranslationReq).fill(supportedCultures);
        (this.text! as TranslationReq).fill(supportedCultures);
    }
}
